export default __webpack_public_path__ + "static/media/phones.434aa33d.png";